import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { camion_sucursal } from 'src/app/shared/object/camion_sucursal.model';
import { camion_sucursalJoin } from 'src/app/shared/object/camion_sucursalJoin.model';
import { DecimalPipe } from '@angular/common';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { SecurityService } from '../../../shared/services/security.service';
import { camion } from 'src/app/shared/object/camion.model';
import { ValidadoresService } from '../../../shared/validadores/validadores';
import { ModalService } from '../../../shared/services/modal.service';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { UnidadNegocioService } from "src/app/services/unidad-negocio.service"
import { ParametroEmpresaService } from "src/app/services/parametro-empresa.service";
import { ConsoleService } from "src/app/shared/services/console.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { ToastService } from 'ng-uikit-pro-standard';
import { ChoferSucursalService } from 'src/app/services/chofer-sucursal.service';
import { CamionChoferService } from 'src/app/services/camion-chofer.service';

@Component({
  selector: 'app-camion',
  templateUrl: './camion.component.html',
  styleUrls: ['./camion.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class CamionComponent implements OnInit {
  private client: GraphQLClient = null;
  camionList: camion_sucursalJoin[];
  selectedCamion: camion_sucursalJoin;
  camion: camion_sucursalJoin;
  optionsUnidadNegocio: Array<any> = [];
  public parametroNegocio: boolean = false;
  public formAgregarCamion_Sucursal: FormGroup;
  public formEditarCamion_Sucursal: FormGroup;
  private log: any
  public rut_empresa;
  public sucursal_codigo;
  optionsChofer: Array<any> = [];
  choferSeleccionado: number


  public tipobusqueda;

  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('centralLargex', { static: true }) editarModal: ModalDirective;
  public codgo_modulo: number = 13;
  public rut_usuario = Number(this.accesolocalstorage.getRutUsuario());

  constructor(private _privatemodalService: ModalService,
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private validadores: ValidadoresService,
    private unidadNegocioService: UnidadNegocioService,
    private parametroEmpresaService: ParametroEmpresaService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private choferSucursalService: ChoferSucursalService,
    private camionChoferService: CamionChoferService,
  ) {
    this.client = client;
    this.formAgregarCamion_Sucursal = this.construyeFormAgrega();
    this.formEditarCamion_Sucursal = this.construyeFormEdita();
    this.tipobusqueda = 1;
    this.log = this.clog.log('CAMION FORM ADD/EDIT')
  }

  ngOnInit() {
    this.selectedCamion = {
      patente: '',
      descripcion: '',
      peso_maximo: null,
      volumen: null,
      fecha_creacion: null,
      fecha_asignacion: null,
      activo: null,
      rut_empresa: null,
      sucursal_codigo: null,
      listaCamionUnidadNegocio: null,
      rut_chofer: null
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();

    this.obtenerDatosCamion(Number(this.rut_empresa), Number(this.sucursal_codigo));
    this.loadUnidadNegocio()
    this.loadChofer();
  }



  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rut_empresa,
        tipo: 1
      }
    }
    this.optionsUnidadNegocio = []
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsUnidadNegocio = registros.map(unidad_negocio => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre
      }))
    })
  }

  showSuccess() {
    const options = { opacity: 1 };
    this.toastService.success('Registro grabado!', 'Información!', options);
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(this.rut_empresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.parametroNegocio = respuesta.valor_bool
      this.log('Permite Unidad Negocio', this.parametroNegocio)
    })
  }

  construyeFormAgrega() {
    return new FormGroup
      ({
        patente: new FormControl('', [this.validadores.ValidaFormatoPatente]),
        descripcion: new FormControl('', [Validators.maxLength(100)]),
        volumen: new FormControl('', [Validators.required, Validators.min(1)]),
        peso_maximo: new FormControl('', [Validators.required, Validators.min(1)]),
        activo: new FormControl(true),
        unidad_negocio_codigo: new FormControl(''),
        chofer: new FormControl(''),
      });
  }

  construyeFormEdita() {
    return new FormGroup
      ({
        rut_empresa: new FormControl(''),
        sucursal_codigo: new FormControl(''),
        patente: new FormControl({ value: '', disabled: true }, [this.validadores.ValidaFormatoPatente]),
        descripcion: new FormControl('', [Validators.maxLength(100)]),
        volumen: new FormControl('', [Validators.required, Validators.min(1)]),
        peso_maximo: new FormControl('', [Validators.required, Validators.min(1)]),
        activo: new FormControl(true),
        unidad_negocio_codigo: new FormControl(''),
        chofer: new FormControl('')
      });
  }


  filtraxEstado() {
    this.obtenerDatosCamion(Number(this.rut_empresa), Number(this.sucursal_codigo));
  }


  obtenerDatosCamion(rut_empresa: number, sucursal_codigo: number) {

    let self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query
          ($rut_empresa: Decimal!, $sucursal_codigo:Decimal!, $tipobusqueda: Int)
          {
            camion_sucursal {
              obtenerCamionSucursalxRutEmpresaSucursal (
                rut_empresa:$rut_empresa
                sucursal_codigo:$sucursal_codigo,
                tipobusqueda: $tipobusqueda
                paginaActual:1,
                cantidadRegistrosPorPagina:-1
              ) {
                respuesta {
                  registros {
                    patente
                    descripcion
                    activo
                    fecha_creacion
                    peso_maximo
                    volumen
                    listaCamionUnidadNegocio
                    rut_chofer
                    nombre_chofer
                  }
                }
              }
            }
          },
        `,
        fetchPolicy: 'no-cache',
        variables: {
          'rut_empresa': rut_empresa,
          'sucursal_codigo': sucursal_codigo,
          'tipobusqueda': this.tipobusqueda
        },

      },
      function (respuesta) {
        self.camionList = respuesta.data.camion_sucursal.obtenerCamionSucursalxRutEmpresaSucursal.respuesta.registros;
      }
    );
  }

  ValidaQueExisteDatosCamion() {

    let self = this; // this is unused
    var datacamion: camion_sucursalJoin = new camion_sucursalJoin();
    datacamion.patente = String(this.frmAgregaPatente.value).toUpperCase();
    datacamion.rut_empresa = Number(this.rut_empresa);
    datacamion.sucursal_codigo = Number(this.sucursal_codigo);


    this.client.query(
      {
        query: gql`
          query
          ($entidad: camion_sucursalJoinInputType)
          {
            camion_sucursal {
              existeCamionSucursalJoin (
                entidad:$entidad
              ) {
                respuesta
              }
            }
          },
        `,
        fetchPolicy: 'network-only',
        variables: {
          'entidad': datacamion
        },

      },
      function (respuesta) {

        if (respuesta.data.camion_sucursal.existeCamionSucursalJoin.respuesta) {
          var res = window.confirm('La patente ingresada ya existe. ¿Desea sobreescribirla?');
          if (res) {
            self.insertar();
          }
        } else {
          self.insertar();
        }
      }
    );
  }

  cambiaEstado(camion_seleccionado: camion_sucursalJoin) {
    camion_seleccionado.rut_empresa = (Number(this.rut_empresa));
    camion_seleccionado.sucursal_codigo = (Number(this.sucursal_codigo));
    if (camion_seleccionado.activo) {
      camion_seleccionado.activo = false;
    } else {
      camion_seleccionado.activo = true;
    }
    this.refrescar(camion_seleccionado);
  }


  agregar() {
    this.selectedCamion = {
      patente: '',
      descripcion: '',
      peso_maximo: 0,
      volumen: 0,
      fecha_creacion: null,
      fecha_asignacion: null,
      activo: true,
      rut_empresa: null,
      sucursal_codigo: null,
      listaCamionUnidadNegocio: null,
      rut_chofer: null
    };
    this.formAgregarCamion_Sucursal.reset();
  }

  get frmAgregaPatente() { return this.formAgregarCamion_Sucursal.get('patente'); }
  get frmAgregaDescripcion() { return this.formAgregarCamion_Sucursal.get('descripcion'); }
  get frmAgregaPeso_Maximo() { return this.formAgregarCamion_Sucursal.get('peso_maximo'); }
  get frmAgregaVolumen() { return this.formAgregarCamion_Sucursal.get('volumen'); }
  get frmAgregaActivo() { return this.formAgregarCamion_Sucursal.get('activo'); }
  get frmAgregaUnidadNegocio() { return this.formAgregarCamion_Sucursal.get('unidad_negocio_codigo'); }
  get frmAgregaChofer() { return this.formAgregarCamion_Sucursal.get('chofer'); }

  get frmEditaPatente() { return this.formEditarCamion_Sucursal.get('patente'); }
  get frmEditaDescripcion() { return this.formEditarCamion_Sucursal.get('descripcion'); }
  get frmEditaPeso_Maximo() { return this.formEditarCamion_Sucursal.get('peso_maximo'); }
  get frmEditaVolumen() { return this.formEditarCamion_Sucursal.get('volumen'); }
  get frmEditaActivo() { return this.formEditarCamion_Sucursal.get('activo'); }
  get frmEditaRut_Empresa() { return this.formEditarCamion_Sucursal.get('rut_empresa'); }
  get frmEditaSucursal_codigo() { return this.formEditarCamion_Sucursal.get('sucursal_codigo'); }
  get frmEditaUnidadNegocio() { return this.formEditarCamion_Sucursal.get('unidad_negocio_codigo'); }
  get frmEditaChofer() { return this.formEditarCamion_Sucursal.get('chofer'); }

  insertar() {
    const inputParams = {
      patente: this.frmAgregaPatente.value,
      descripcion: this.frmAgregaDescripcion.value,
      peso_maximo: this.frmAgregaPeso_Maximo.value,
      volumen: this.frmAgregaVolumen.value,
      fecha_creacion: null,
      activo: this.frmAgregaActivo.value,
      fecha_asignacion: null,
      rut_empresa: Number(this.rut_empresa),
      sucursal_codigo: Number(this.sucursal_codigo),
      listaCamionUnidadNegocio: this.formAgregarCamion_Sucursal.get('unidad_negocio_codigo').value,
      rut_chofer: this.formAgregarCamion_Sucursal.get('chofer').value,
    }
    this.log('INSERTAR', JSON.stringify(inputParams),)
    this.postCamion(inputParams);
    this.formAgregarCamion_Sucursal.reset();

  }

  postCamion(inputParams) {
    let self = this;
    var bodyx = inputParams;
    //var self = this;
    this.client.mutate(
      {
        mutation: gql`
        mutation ($entidad: camion_sucursalJoinInputType) {
          camion_sucursal {
            agregaroEditarCamionSucursal(entidad: $entidad) {
              mensajes{
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                patente
                descripcion
                activo
              }
            }
          }
        }
        `,
        variables: {
          entidad: bodyx
        }
      },
      function (respuesta) {
        const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.camion_sucursal.agregaroEditarCamionSucursal);
        if (respuesta.data.camion_sucursal.agregaroEditarCamionSucursal.respuesta == null) {
          if (respuesta.data.camion_sucursal.agregaroEditarCamionSucursal.mensajes.length > 0) {
            self.messageRendererService.showErrors(notificacion.mensajes)
            return
          }
        } else {
          self.agregarModal.hide();
          self.showSuccess()
          setTimeout(() => self.obtenerDatosCamion(Number(self.rut_empresa), Number(self.sucursal_codigo)), 1000);
        }
      }
    );
  }


  actualizar() {

    const inputParams = {
      patente: this.frmEditaPatente.value,
      descripcion: this.frmEditaDescripcion.value,
      peso_maximo: this.frmEditaPeso_Maximo.value,
      volumen: this.frmEditaVolumen.value,
      fecha_creacion: null,
      activo: this.frmEditaActivo.value,
      fecha_asignacion: null,
      rut_empresa: this.rut_empresa,
      sucursal_codigo: this.sucursal_codigo,
      listaCamionUnidadNegocio: this.formEditarCamion_Sucursal.get('unidad_negocio_codigo').value,
      rut_chofer: this.formEditarCamion_Sucursal.get('chofer').value,
    }
    this.log('SELECCION', JSON.stringify(inputParams),)
    this.refrescar(inputParams);

  }

  showForEdit(cam: camion_sucursalJoin) {
    this.formEditarCamion_Sucursal.reset();
    this.selectedCamion = Object.assign({}, cam);
    this.frmEditaPatente.setValue(cam.patente);
    this.frmEditaDescripcion.setValue(cam.descripcion);
    this.frmEditaPeso_Maximo.setValue(cam.peso_maximo);
    this.frmEditaVolumen.setValue(cam.volumen);
    this.frmEditaRut_Empresa.setValue(cam.rut_empresa);
    this.frmEditaSucursal_codigo.setValue(cam.sucursal_codigo);
    this.frmEditaActivo.setValue(cam.activo);
    this.formEditarCamion_Sucursal.get('unidad_negocio_codigo').setValue(cam.listaCamionUnidadNegocio);
    this.obtenerChoferCamion(cam)
    this.log('Unidad medida', this.frmEditaUnidadNegocio.value,)
  }

  obtenerChoferCamion(cam: any) {
    const inputParams = {
      entidad: {
        patente: cam.patente,
      },
    };
    this.camionChoferService.obtenerSegunPatente(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.choferSeleccionado = respuesta === null ? 0 : respuesta.rut_chofer;
      this.formEditarCamion_Sucursal.get('chofer').setValue(this.choferSeleccionado);

    });
  }

  refrescar(inputParams) {
    let self = this;
    var bodyx = inputParams;

    delete inputParams['__typename'];
    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: camion_sucursalJoinInputType) {
            camion_sucursal {
              agregaroEditarCamionSucursal(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  patente
                  descripcion
                  activo
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx
        }
      },
      function (respuesta) {
        const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.camion_sucursal.agregaroEditarCamionSucursal);
        if (respuesta.data.camion_sucursal.agregaroEditarCamionSucursal.respuesta == null) {
          if (respuesta.data.camion_sucursal.agregaroEditarCamionSucursal.mensajes.length > 0) {
            self.messageRendererService.showErrors(notificacion.mensajes)
            return
          }
        } else {
          self.editarModal.hide();
          self.showSuccess()
          setTimeout(() => self.obtenerDatosCamion(Number(self.rut_empresa), Number(self.sucursal_codigo)), 1000);
        }
      }
    );
  }

  showModalAgregar() {
    this.frmAgregaActivo.setValue(true);
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.parametroUnidadNegocio()
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.parametroUnidadNegocio()
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(camion_seleccionado: camion_sucursalJoin) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(camion_seleccionado);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  loadChofer() {
    const inputParams = {
      entidad: {
        rut_empresa: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        tipobusqueda: 1,
      },
    };
    this.choferSucursalService.obtenerchoferSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsChofer = registros.map((p) => ({ value: p.rut, label: p.nombre, ...p }));
    });
  }
}
